import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 flex items-center justify-center min-h-[60vh]">
        <div className="text-center px-4">
          <div className="text-8xl font-bold text-primary-500 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>404</div>
          <h1 className="text-2xl font-bold text-foreground-950 mb-2 whitespace-nowrap">页面未找到</h1>
          <p className="text-foreground-600 text-sm mb-8">您访问的页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-semibold transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i> 返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}